import L from "leaflet";
import { toAbsoluteUrl } from "../../../infofleet/utils/utils";
import {

  MovingBikeIcon,
  ParkedBikeIcon,
  NosignalBikeIcon,
  StoppedBikeIcon,
  // MovingpointerIcon,
  ParkedpointerIcon,
  StoppedpointerIcon,
  NosignalpointerIcon,
  AnimatedIcon,
  AnimatedIdleIcon,

} from './MapIcons'

const MovingpointerIconWithArrow = new L.DivIcon({
  className: "",
  html: `<div style="display: flex; flex-direction: column; align-items: center; width: 15px; height: 50px;">
           <div style="width: 0; height: 0; border-left: 5px solid transparent; border-right: 5px solid transparent; border-bottom: 10px solid #3e7d0a;"></div>
           <img src="${toAbsoluteUrl("/media/icons/Mapicons/Car-icon_green.png")}" style="width: 15px; height: 30px; display: block;" />
           <div style="height: 10px; width: 100%;"></div>
         </div>`,
  iconSize: [15, 50],
  iconAnchor: [7.5, 25],
});

function RotatedMarkerIcon(item) {

  return (
    item.idleViolationOn === 1
      ? AnimatedIdleIcon
      : item.speedViolationOn === 1
        ? AnimatedIcon
        : item.vmode === "Parked"
          ? item.vehicleType === "Bike"
            ? ParkedBikeIcon
            : ParkedpointerIcon
          : item.vmode === "Moving"
            ? item.vehicleType === "Bike"
              ? MovingBikeIcon
              : MovingpointerIconWithArrow
            : item.vmode === "No Signal"
              ? item.vehicleType === "Bike"
                ? NosignalBikeIcon
                : NosignalpointerIcon
              : item.vmode === "Stopped"
                ? item.vehicleType === "Bike"
                  ? StoppedBikeIcon
                  : StoppedpointerIcon
                : ParkedpointerIcon
  )
}

export default RotatedMarkerIcon;